export default __webpack_public_path__ + "5d924a0ff74e8886520f40e78d1d8210.svg";